<template>
	<div class="my-3">
		<p>Non-Contractual Bonus Proof</p>
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form class="demo-dynamic">
				<b-row>
					<b-col md="8" cols="12">
						<div v-if="bonuses.length > 0">
							<b-form-group v-for="(bonus, index) in bonuses" :key="bonus.key" :label="'Bonus Year ' + `${index + 1}`"
								label-cols="5" label-cols-md="4">
								<div class="d-flex align-items-center">
									<CurrencyInput v-model="bonus.amount"
										:options="currencyOptions" />
									<svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeBonus(bonus)"
										class="text-danger cursor-pointer mx-2" width="20" height="20" viewBox="0 0 512 512">
										<path fill="currentColor"
											d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512zm-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
									</svg>
								</div>
							</b-form-group>
						</div>
						<b-button @click="addBonus" block variant="outline-primary" class="my-3" v-if="bonuses.length < 3">+
							Add</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</div>
</template>

<script>
import { Button, Form, FormItem } from 'element-ui'
import {
	notifyFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	props: ['customer', 'main_form', 'currencyOptions'],
	components: {
		CurrencyInput,
		ValidationObserver,
		ValidationProvider,
		[Button.name]: Button,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
	},
	mixins: [
		notifyFunctionMixin,
	],
	data(){
		return {
			bonuses: []
		}
	},	
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		initData(){
			this.bonuses = _gHlp.getValue(this.customer,'incomes.bonus',[]);
			if(this.isForeigIncome){
				this.bonuses.forEach(el => {
					el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate)
				});
			}
		},
		setData() {
			let bonuses = this.bonuses.map((obj, index) => {
				return {
					...(obj.customer_bonus_income_id && { customer_bonus_income_id: obj.customer_bonus_income_id }),
					amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount,
					year: index + 1,
				}
			})

			let data = { bonuses: bonuses, }
			return data
		},
		update() {
			let data = this.setData()
			axios.post(services.customer + 'customer/' + this.customer.customer_id + '/income/bonuses', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Bonus Income: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.customer.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		removeBonus(item) {
			if (this.bonuses.length > 0) {
				var index = this.bonuses.indexOf(item);
				this.bonuses.splice(index, 1);
			}
		},
		addBonus() {
			if (this.bonuses.length < 3) {
				this.bonuses.push({ amount: null });
			}
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		}
	}
}
</script>